<template>
  <TeaserAccountTile
    :title="$t('registrationSuccessfulPage.title')"
    :text="$t('registrationSuccessfulPage.text')"
    :primaryButtonText="$t('registrationSuccessfulPage.primaryButtonText')"
    :primaryButtonLink="url"
    :primaryButtonColor="ButtonColor.LINK"
    :openLinkInSameTab="true"
  ></TeaserAccountTile>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import { ButtonColor } from 'de-zurich-ui-library'

const { t } = useI18n()
const url = ref('')

onMounted(() => {
  if (
    t('registrationSuccessfulPage.primaryButtonText') !==
    'registrationSuccessfulPage.primaryButtonText'
  ) {
    url.value = 'https://da-direkt.de/'
  }
})
</script>
